import { render, staticRenderFns } from "./VoltageRecord.vue?vue&type=template&id=0f880514&scoped=true&"
import script from "./VoltageRecord.vue?vue&type=script&lang=js&"
export * from "./VoltageRecord.vue?vue&type=script&lang=js&"
import style0 from "./VoltageRecord.vue?vue&type=style&index=0&id=0f880514&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f880514",
  null
  
)

export default component.exports